module.exports = __webpack_public_path__ + "img/imgVirtualTryOn03.bc1ca880.png";